import { render, staticRenderFns } from "./DocumentPreviewAdf.vue?vue&type=template&id=8097afa4&"
import script from "./DocumentPreviewAdf.vue?vue&type=script&lang=js&"
export * from "./DocumentPreviewAdf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports